import { createSelector } from 'reselect';
/**
 * Takes in a selector (which could return null) and a combiner (which does not accept null) and
 * returns a new selector which will return null if result from the selector is null (and does not call the combiner)
 */
export function createMaybeSelector(selector, combiner) {
    return createSelector(selector, function (x) {
        return x == null ? null : combiner(x);
    });
}
/**
 * Takes in two selectors (which could return null) and a combiner (which does not accept null) and
 * returns a new selector which will return null if result from either selector is null (and does not call the combiner)
 */
export function createMaybeSelectorS2(selector1, selector2, combiner) {
    return createSelector(selector1, selector2, function (x, y) {
        return x == null || y == null ? null : combiner(x, y);
    });
}
//# sourceMappingURL=createMaybeSelector.js.map